import React from "react";

const PageLoader = ({ minHeight = "100vh" }) => (
  <div className="dunta-page-loader" style={{ minHeight }}>
    <div className="expand-spinner-wrapper" role="status" aria-label="Loading">
      <div className="expand-spinner-box" />
    </div>
  </div>
);

export default PageLoader;
